module.exports = __webpack_public_path__ + "static/mo-988bf817e7bd5b337c9bf2c414b1cea5.png";